<template>
  <div>
    <Navigation />
    <div class="pa-5 flex space-between">
      <WorkstationFilters />
      <ElButton @click="$refs.workstationDialog.add()" type="primary"
        >Adauga Post de Lucru</ElButton
      >
    </div>
    <!-- table -->
    <ResourceTable
      :query="query"
      :filter="filter"
      :default-sort="{ prop: 'data.name' }"
    >
      <ElTableColumn type="index" width="50" />
      <ElTableColumn prop="data.name" label="Nume" sortable />
      <ElTableColumn label="Culoare">
        <div
          slot-scope="{ row }"
          :style="{ background: row.data.color, width: '50px' }"
        >
          &nbsp;
        </div>
      </ElTableColumn>
      <ElTableColumn label="Creare" sortable sort-by="data.createdAt.seconds">
        <TimeAgo
          slot-scope="{ row }"
          v-if="row.data.createdAt"
          :date="row.data.createdAt.toDate()"
        />
      </ElTableColumn>
      <ElTableColumn
        label="Actualizare"
        sortable
        sort-by="data.updatedAt.seconds"
      >
        <TimeAgo
          slot-scope="{ row }"
          v-if="row.data.updatedAt"
          :date="row.data.updatedAt.toDate()"
        />
      </ElTableColumn>
      <ElTableColumn align="right">
        <template slot-scope="{ row }">
          <ElButton @click="$refs.workstationDialog.edit(row.id)" size="mini"
            >Modifica</ElButton
          >
        </template>
      </ElTableColumn>
    </ResourceTable>
    <!-- dialogs -->
    <WorkstationDialog ref="workstationDialog" />
  </div>
</template>

<script>
import FiltersMixin from "@/mixins/FiltersMixin";
import WorkstationDialog from "@/components/workstations/WorkstationDialog";
import WorkstationFilters from "@/components/workstations/WorkstationFilters";

export default {
  mixins: [FiltersMixin()],
  components: {
    WorkstationDialog,
    WorkstationFilters
  },
  computed: {
    query() {
      return this.$firestore().collection("workstations");
    }
  },
  methods: {
    filter(row) {
      const { filters } = this;
      if (filters.name) {
        if (row.data.name.match(new RegExp(filters.name, "i")) === null) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>
